import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { notify } from '@/lib/notify';
import {
    LURE_EXAMPLE,
    ROD_EXAMPLE,
    TEMPLATE_COLUMNS,
    TEMPLATE_CSV_PATH,
    TEMPLATE_HELP_PATH,
} from '../suppliers/templateManual';

async function copyText(text: string) {
    try {
        await navigator.clipboard.writeText(text);
        notify({ type: 'ok', text: 'Ejemplo copiado' });
    } catch {
        notify({ type: 'err', text: 'No se ha podido copiar' });
    }
}

export function TemplateHelpPage() {
    return (
        <div className="mx-auto max-w-3xl space-y-8">
            <div className="space-y-2">
                <h1 className="text-xl font-semibold">Instrucciones de la plantilla</h1>
                <p className="text-sm text-muted-foreground">
                    Un CSV y un ZIP de fotos. Vale para cualquier proveedor que no se actualice solo.
                    Esta página no está en la tienda pública ni en el menú. La dirección es {TEMPLATE_HELP_PATH}.
                </p>
            </div>

            <section className="space-y-2">
                <h2 className="text-sm font-semibold">Archivos</h2>
                <p className="text-sm text-muted-foreground">
                    <a className="font-medium text-primary hover:underline" href={TEMPLATE_CSV_PATH} download>
                        Descargar la plantilla CSV
                    </a>
                    . La fila EXAMPLE no entra. Si el archivo empieza por {'{'} o [, se rechaza: la plantilla es CSV.
                </p>
                <p className="text-sm text-muted-foreground">
                    El ZIP contiene las fotos. En foto, fotos y foto_variante se escribe el nombre del archivo, sin la carpeta y sin una URL.
                    Sin ZIP, la fila entra y la foto queda pendiente. No es un fallo definitivo.
                </p>
            </section>

            <section className="space-y-2">
                <h2 className="text-sm font-semibold">Orden</h2>
                <ol className="list-decimal space-y-1 pl-5 text-sm text-muted-foreground">
                    <li>En la ficha del proveedor, pestaña Conexión, subir el ZIP.</li>
                    <li>Subir el CSV. El archivo es la selección: entra lo que trae, sin otra lista.</li>
                    <li>Leer la previsualización: altas, precios, stock y filas rechazadas.</li>
                    <li>Pulsar Sincronizar ahora para aplicarlo. Las fichas nuevas entran inactivas.</li>
                </ol>
            </section>

            <section className="space-y-2">
                <h2 className="text-sm font-semibold">Segunda subida</h2>
                <p className="text-sm text-muted-foreground">
                    Se actualizan precio, unidades, disponibilidad y las variantes nuevas.
                    Nombre, textos, SEO, marca y la ruta de categoría ya guardados se quedan.
                    La ficha técnica del CSV se vuelve a aplicar hasta que alguien la edite en el Portal.
                    Cada subida deja una copia fechada y una ejecución al sincronizar.
                    Un proveedor de esta plantilla no entra en el cron de las 05:00.
                    JLC y Onnautic no usan esta plantilla: se actualizan solos.
                    El texto y el SEO de una ficha ya creada se corrigen en{' '}
                    <Link className="text-primary underline" to="/store/ayuda/fichas">/store/ayuda/fichas</Link>.
                </p>
            </section>

            <section className="space-y-2">
                <h2 className="text-sm font-semibold">Columnas</h2>
                <div className="overflow-x-auto rounded-lg border border-border">
                    <table className="w-full text-sm">
                        <tbody>
                            {TEMPLATE_COLUMNS.map((column) => (
                                <tr key={column.name} className="border-b border-border last:border-0">
                                    <th className="whitespace-nowrap px-3 py-2 text-left font-mono text-xs font-medium">{column.name}</th>
                                    <td className="px-3 py-2 text-muted-foreground">{column.meaning}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <Example title="Caña con dos longitudes" csv={ROD_EXAMPLE} />
            <Example title="Señuelo sin variantes" csv={LURE_EXAMPLE} />

            <p className="text-sm text-muted-foreground">
                <Link className="text-primary underline" to="/store/suppliers">Volver a proveedores</Link>
            </p>
        </div>
    );
}

function Example({ title, csv }: { title: string; csv: string }) {
    return (
        <section className="space-y-2">
            <div className="flex items-center justify-between gap-2">
                <h2 className="text-sm font-semibold">{title}</h2>
                <Button type="button" variant="outline" size="sm" onClick={() => void copyText(csv)}>
                    Copiar ejemplo
                </Button>
            </div>
            <pre className="overflow-x-auto rounded-lg border border-border bg-muted/30 p-3 text-xs">{csv}</pre>
        </section>
    );
}
